module.exports = __webpack_public_path__ + "assets/img/17_961_big.9c261bb6.jpg";